export default "https://assets-v2.scaler.com/packs/files/jbl-go-2.14ef79.webp";